<template>
    <div class="role-manage">
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>角色管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="80px">
                <el-form-item label="系统">
                    <el-select size="small" v-model="formInline.companyId" placeholder="请选择系统" clearable filterable>
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="角色名称">
                    <el-input size="small" v-model="formInline.roleName" placeholder="请输入角色名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" size="small" type="primary" @click="onSubmit">查 询</el-button>
                    <el-button icon="el-icon-plus" size="small" type="primary" @click="changeRoleInfo">新 增</el-button>
                    <el-button icon="el-icon-document-copy" size="small" type="primary" @click="copyRole">复 制</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-table
                :data="tableData"
                v-loading="loading"
                style="width: 100%; padding-bottom: 20px;"
                :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="index"
                    width="55"
                    label="序号"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="roleName"
                    label="角色名称">
                </el-table-column>
                <el-table-column
                    prop="companyName"
                    label="系统名称">
                </el-table-column>
                <el-table-column
                    prop="roleKey"
                    label="权限字符">
                </el-table-column>
                <el-table-column
                    label="创建时间"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-dropdown>
                            <el-button size="mini" type="primary">
                                更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="changeRoleInfo(scope.row)">编 辑</el-dropdown-item>
                                <el-dropdown-item @click.native="deleteRoleItem(scope.row.roleId)">删 除</el-dropdown-item>
                                <el-dropdown-item @click.native="setDataPermission(scope.row)">数据权限</el-dropdown-item>
                                <el-dropdown-item @click.native="toAssignmentRolePage(scope.row)">分配用户</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                background
                @size-change="handleSizeChange"
                @current-change="changePage"
                :current-page="formInline.pageNo"
                :page-sizes="[10, 20, 50, 100, 200]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </el-card>
        <!-- 设置数据权限 -->
        <!-- <el-dialog
            title="数据权限"
            :visible.sync="setDataVisible"
            append-to-body
            width="40%"
            top="5vh"
            :before-close="handleClose"
        >
            <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input v-model="dataForm.roleName" placeholder="请输入活动名称" disabled></el-input>
                </el-form-item>
                <el-form-item label="数据范围" prop="dataScope">
                    <el-select v-model="dataForm.dataScope" placeholder="请选择数据范围" style="width: 100%;">
                        <el-option
                            v-for="item in dataScopeOptions"
                            :key="item.scopeId"
                            :label="item.scopeName"
                            :value="item.scopeId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据权限" prop="groupIds" v-if="dataForm.dataScope === 2 ">
                    <el-tree
                        :data="treeList"
                        show-checkbox
                        node-key="groupId"
                        ref="treeData"
                        highlight-current
                        @check-change="checkChange"
                        :props="departProps">
                    </el-tree>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="setDataVisible = false">取 消</el-button>
                <el-button type="primary" @click="setDataPermissionInfo('dataForm')">确 定</el-button>
            </span>
        </el-dialog> -->
        <!-- 复制角色 -->
        <el-dialog
            title="复制"
            :visible.sync="copyVisible"
            width="30%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="copyRuleForm" :rules="rules" ref="copyRuleForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="原系统" prop="companyId">
                    <el-select
                        size="small"
                        style="width: 100%;"
                        v-model="copyRuleForm.companyId"
                        placeholder="请选择源系统"
                        clearable
                        filterable>
                        <el-option
                            v-for="item in allCompanyList"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标系统" prop="oldCompanyId">
                    <el-select
                        size="small"
                        style="width: 100%;"
                        filterable
                        v-model="copyRuleForm.oldCompanyId"
                        placeholder="请选择目标系统"
                        clearable
                        multiple>
                        <el-option
                            v-for="item in allCompanyList"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopyRole('copyRuleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/*
* TODO 新增修改需要进行系统判断，判断用户是否选择了系统
* **/
import { getRoleList, deleteRoleInfo, addRoleGroup, copyRoleInfo } from '@/api/roleMange';
import { findPageCompany } from '@/api/postManage';
import { getSystemData } from "@/api/systemMange";
import { getMenuList } from "@/api/menuMange";
import { hasBtnPermission } from "@/utils";
import { getRoleAuthDepartInfo } from '@/api/departMange'

export default {
    name: "RoleManage",
    data() {
        return {
            loading: false,
            addVisible: false, // 新增角色弹框
            setDataVisible: false, // 设置数据权限
            copyVisible: false,
            title: '', // 弹框标题
            totalCount: null,
            formInline: {
                companyId: '',
                roleName: '',
                userStatus: '-1',
                createTime: '',
                pageNo: 1,
                pageSize: 10,
            },
            dataScopeOptions: [
                { scopeId: 1, scopeName: '全部数据权限' },
                { scopeId: 2, scopeName: '自定数据权限' },
                { scopeId: 3, scopeName: '本部门数据权限' },
                { scopeId: 4, scopeName: '本部门及以下数据权限' },
                { scopeId: 5, scopeName: '仅本人数据权限' },
            ],
            companyOptions: [],
            multipleSelection: [],
            tableData: [],
            // 设置权限数据
            dataForm: {
                companyId: '',
                roleId: '',
                roleName: '', // 角色名称
                dataScope: '', // 数据范围
                groupIds: [], // 部门ID集合
                userId: ''
            },
            rules: {
                roleName: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' }
                ],
                dataScope: [
                    { required: true, message: '请选择数据范围', trigger: ['blur', 'change'] }
                ],
                companyId: [
                    { required: true, message: '请选择源系统', trigger: ['blur', 'change'] }
                ],
                oldCompanyId: [
                    { required: true, message: '请选择目标系统', trigger: ['blur', 'change'] }
                ]
            },
            menuList: [],
            defaultProps: {
                children: 'children',
                label: 'menuName'
            },
            allCompanyList: [],
            copyRuleForm: {
                companyId: '',
                oldCompanyId: ''
            }
        }
    },
    watch: {
        "dataForm.dataScope"(newVal, oldVal){
            if(newVal == 2){
                this.getRoleTreeList()
            }
        }
    },
    created() {
        // this.getAllSystemInfo()
    },
    activated() {
        this.getAllSystemInfo()
        this.getRoleDataList()
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo() {
            let searchSystemParams = {
                pageNo: 1,
                pageSize: 100,
                companyName: '',
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await getSystemData(searchSystemParams);
            if (res.code == 200) {
                this.companyOptions = res.data.list
            } else {
                this.$message.error(res.msg)
            }
        },
        // 获取角色信息列表
        async getRoleDataList() {
            this.loading = true
            const res = await getRoleList(this.formInline);
            if (res.code === '200') {
                this.tableData = res.data.list
                this.totalCount = res.data.total
            } else {
                this.$message.error(res.msg)
            }
            this.loading = false
        },
        // 获取所有菜单
        getDepartList(){
            this.getMenuTreeList()
        },
        // 查询系统的所有菜单列表
        async getMenuTreeList() {
            let param = {
                companyId: this.roleForm.companyId,
                menuName: ''
            }
            const res = await getMenuList(param);
            if (res.code === '200') {
                this.menuList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        // 查询
        onSubmit() {
            if(!hasBtnPermission('sys:role:list')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.getRoleDataList();
        },
        // table表格数据选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 设置dialog标题
        changeRoleInfo(item) {
            if(item.roleName){
                if(!hasBtnPermission('sys:role:update')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                // this.title = '编辑'
                // this.roleForm = JSON.parse(JSON.stringify(item))
                // this.getDepartList()
            }else{
                if(!hasBtnPermission('sys:role:save')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.title = '新增'
            }
            this.$router.push({
                path: '/sys/role/addRole',
                query: {
                    item: JSON.stringify(item)
                }
            })
            // this.addVisible = true
        },
        // 删除用户角色
        deleteRoleItem(roleId) {
            if(!hasBtnPermission('sys:role:delete')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$confirm('确认删除该数据吗？', '提示')
                .then(_ => {
                    this.confirmDelete(roleId)
                })
                .catch(_ => {
                })
        },
        // 确认删除
        async confirmDelete(roleId) {
            const res = await deleteRoleInfo(roleId);
            if (res.code === '200') {
                this.$message.success('删除成功')
                this.getRoleDataList()
            } else {
                this.$message.error(res.msg)
            }
        },
        // 设置权限数据
        checkChange(data, checked, node){
            this.dataForm.groupIds = this.$refs.treeData.getCheckedKeys();
        },
        // 设置权限
        setDataPermission(item){
            this.$router.push({
                path: '/rolemange/rolejurisdiction',
                query: {
                    item: JSON.stringify(item)
                }
            })
        },
        // 查询角色数据权限分配的树结构
        async getRoleTreeList(){
            const that = this;
            let params = {
                companyId: this.dataForm.companyId,
                roleId: this.dataForm.roleId,
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await getRoleAuthDepartInfo(params);
            if(res.code === '200'){
                this.treeList = res.data
                this.$nextTick(function(){
                    that.$refs.treeData.setCheckedKeys(that.itemMenuIds, true);
                })
            }else{
                this.$message.error(res.msg)
            }
        },
        // 设置数据权限弹框确定时间
        setDataPermissionInfo(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmSetDataPermission();
                } else {
                    return false;
                }
            });
        },
        async confirmSetDataPermission(){
            this.dataForm.userId = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await addRoleGroup(this.dataForm);
            if(res.code === '200'){
                this.$message.success('修改成功')
                this.setDataVisible = false
                this.getRoleDataList()
            }else{
                this.$message.error(res.msg)
            }
        },
        // 前往用户分配页面
        toAssignmentRolePage(item){
            this.$router.push({
                path: '/roleManage/assignmentRole',
                query: {
                    roleId: item.roleId,
                    companyId: item.companyId,
                    userIds: item.userIds
                }
            })
        },
        // 复制角色
        copyRole(){
            this.copyVisible = true
            this.getAllPositionList()
        },
        // 查询所有系统信息
        async getAllPositionList(){
            const res = await findPageCompany();
            if(res.code === '200') {
                this.allCompanyList = res.data
            }else{
                this.$message.error(res.msg)
            }
        },
        confirmCopyRole(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmCopyCompany()
                } else {
                    return false;
                }
            });
        },
        async confirmCopyCompany(){
            const res = await copyRoleInfo(this.copyRuleForm);
            if(res.code === '200'){
                this.$message.success('复制成功')
                this.copyVisible = false
            }else{
                this.$message.error(res.msg)
            }
        },
        changePage(e) {
            this.formInline.pageNo = e
            this.getRoleDataList()
        },
        handleSizeChange(e){
            this.formInline.pageNo = 1
            this.formInline.pageSize = e;
            this.getRoleDataList()
        },
        handleClose() {
            this.addVisible = false
            this.setDataVisible = false
        },
    }
}
</script>

<style scoped>
::v-deep .el-date-editor--datetimerange {
    width: 380px;
}

::v-deep .el-form--inline {
    height: 40px;
}
</style>
<style scoped lang="scss">
.role-manage {
    .search-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 30px;
    }
    .pagination{
        margin: 20px 0 0;
    }
}
</style>
